import Store from '@/store';
import { canAccessAny, firstAllowedRoute } from '@/access/adminAccess';

export default (...permissions) => function permissionMiddleware(to, from, next) {
  const { user } = Store.state.auth;

  if (canAccessAny(user, permissions)) {
    return next();
  }

  const route = firstAllowedRoute(user);
  if (route === 'login') {
    return next({ name: 'login' });
  }

  if (to.name === route) {
    return next(false);
  }

  return next({ name: route });
};
